import React from 'react';
import { PTCMetadata } from '@api/izibizi-xp';
import { getSessionStorage } from '@helpers';

export const usePTCMetadata = (): PTCMetadata => {
	const contextId = getSessionStorage<string>('contextId');

	return React.useMemo(
		(): PTCMetadata => ({
			alias: 'iziBizi',
			application: '14',
			geo: '1',
			languageCode: 'PT',
			sessionId: contextId || '',
			targetInfrastructure: '21',
			targetSystem: 'PTCorporate',
		}),
		[contextId]
	);
};
